import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function TopThreeCTR() {
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const res = await fetch("https://bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("http://localhost:3000/bonvoytourismbackend/api/packages");
        const data = await res.json();

        if (data.packages?.length) {
          // 🔹 Pick 3 random packages
          const shuffled = data.packages.sort(() => 0.5 - Math.random());
          const selected = shuffled.slice(0, 3);

          setPackages(selected);
        }
      } catch (error) {
        console.error("TopThree packages fetch error:", error);
      }
    };

    fetchPackages();
  }, []);

  if (!packages.length) return null;

  return (
    <div className="mt-12 md:mt-22 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-white">
      {packages.map((pkg) => (
        <Link
          key={pkg.id}
          to={`/tour/${pkg.slug}`}
          // to={`/tour/${pkg.id}`}
          className="relative px-[20px] md:px-[60px] py-[40px] md:py-[60px] bg-cover bg-center text-center group flex flex-col items-center justify-between h-full"
          style={{ backgroundImage: `url('${pkg.img}')` }}
        >
          <div className="absolute inset-0 bg-black/50"></div>

          <div className="relative z-10">
            <h3 className="text-[24px] md:text-[26px] mb-[5px] font-semibold">{pkg.title}</h3>

            <p className="text-[13px] mb-[15px]">
              {pkg.shortDescription || "Explore this tours"}
            </p>
          </div>

          <button
            className="btn-slider text-[12px] border-[3px] border-[#fc9f1c] py-2 px-10 
    transition-all duration-600 ease-in-out max-w-[174px] rounded-[2px] font-medium
    group-hover:bg-[#fc9f1c] group-hover:border-transparent relative overflow-hidden mt-auto"
          >
            View
            <span className="shine"></span>
          </button>
        </Link>

      ))}
    </div>
  );
}
